export const fontCdn: string =
  "https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Open+Sans&display=swap";

export const headlineFont: string = "'Black Han Sans', sans-serif";
export const bodyFont: string = "'Open Sans', sans-serif";
export const fontFamilies: string = `${headlineFont}, ${bodyFont}`;
